import { render, staticRenderFns } from "./CitizenEdit.vue?vue&type=template&id=9da74b4c"
import script from "./CitizenEdit.vue?vue&type=script&lang=js"
export * from "./CitizenEdit.vue?vue&type=script&lang=js"
import style0 from "./CitizenEdit.vue?vue&type=style&index=0&id=9da74b4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports